module.exports = __webpack_public_path__ + "media/images/home/ic_comment-29cdda71b1c79dbff51530867848ff36.svg";